const texts = {
  en: {
    content: "A few of my jobs as a graphic designer and/or some projects that I did in my free time"
  },
  br: {
    content: "alguns dos meus trabalhos como designer gráfico e/ou projetos que fiz no meu tempo livre."
  }
};

export default texts;